import {DataObject} from "./dataObject";

export class Landesverband extends DataObject {
    constructor(){
        super();
        this.id = '';
        this.name = '';
        this.sportart = '';
        this.vereine = null;
        this.ligen = {};
        this.local.definitions.databaseHandlerCall = 'landesverband';
    }

    isNotLigaNameDuplicate(liga){
        let check = true;
        Object.keys(this.ligen).forEach( (ligaId) => {
            if ( ( this.ligen[ligaId].nameFull === liga.nameFull && liga.nameFull !== "" ) ||
                ( this.ligen[ligaId].name === liga.name &&
                  this.ligen[ligaId].type === liga.type
                ) ) {
                if ( liga.id ) {
                    if ( ligaId !== liga.id ) { check = false; }
                } else {
                    check = false;
                }
            }
        });
        return check
    }

    getNextId(){
        console.log ("getNextId", this.ligen);
        let id = 1;
        Object.keys(this.ligen).forEach( (ligaId) => {
            const ligaIdNr = parseInt(ligaId.split('_')[1]);
            console.log ("ligaIdNr: ", ligaIdNr);
            if ( ligaIdNr >= id ) { id = ligaIdNr + 1; }
        });
        return this.id  + "_" + id;
    }

    getVereinsListForAutoComplete(){
        let vereine = [];
        Object.keys(this.vereine).forEach( (vereinsId) => {
            let verein = this.vereine[vereinsId];
            verein.value = vereinsId;
            verein.text = vereinsId + ' - ' + verein.name;
            vereine.push(verein);
        });
        vereine.sort((a, b) => a.text > b.text ? 1 : -1);
        return vereine;
    }

    getVereinsNameById(id){
        return this.vereine[id].name;
    }
}